<div
  *ngIf="!innerTitle"
  class="title"
>{{jobTitle}}</div>
<common-mojo-card>
  <div
    *ngIf="innerTitle"
    class="inner-title"
  >{{jobTitle}}</div>
  <div>
    <div class="right-side">
      Job <span
        class="number-default-font-size">{{allJobs?.totalElements}}</span>
    </div>
    <div class="left-side">
      <div class="left-element">
        {{leftColumnTitle}}
      </div>
      <div class="right-element">
        {{rightColumnTitle}}
      </div>
    </div>
  </div>

  <div class="job-item-wrapper">
    <ng-content select="[job-item]"></ng-content>
  </div>
</common-mojo-card>

<ng-content select="[pagination]"></ng-content>
